import { Component, OnInit,  HostListener } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { Title } from "@angular/platform-browser";
import { Subscription } from "rxjs";
import { AuthenticationService, GoogleAnalyticsService } from "./_services";
import { IUser } from "./_models";
import { AppGlobals } from "./app.globals";
import { StorageService } from "./_services/storage.service";
import { environment } from "../environments/environment";

// declare ga as a function to set and sent the events
declare let ga: Function;

@Component({
    selector: "app",
    templateUrl: "app.component.html",
    styleUrls: ["app.component.css"]
})
export class AppComponent implements OnInit {
    currentUser: IUser;
    pageTitleSubscription: Subscription;

    constructor(private router: Router, private authenticationService: AuthenticationService, private appGlobals: AppGlobals, private storageService: StorageService, private titleService: Title, private googleAnalyticsService: GoogleAnalyticsService) {
        // subscribe to router events and send page views to Google Analytics
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                //ga("create", environment.gaTrackingId, "auto");
                //ga("create", environment.gaStudentPortalTrackingId, "auto", "studentPortalTracker");

                //ga("set", "page", event.urlAfterRedirects);
                //ga("send", "pageview");

                //ga("studentPortalTracker.set", "page", event.urlAfterRedirects);
                //ga("studentPortalTracker.send", "pageview");

                this.googleAnalyticsService.logPageView(event.urlAfterRedirects);
            }
        });

        this.pageTitleSubscription = this.appGlobals.pageTitle.subscribe(value => {
            if (value && value.trim())
                this.titleService.setTitle(`JCU Student Portal - ${value}`);
        });
    }

    ngOnInit() {
        this.authenticationService.currentUser.subscribe(x => this.currentUser = x);

        const timer = JSON.parse(this.storageService.getStorage(this.appGlobals.localStorageKeys.timer));

        if (!sessionStorage.length) {
            // Ask other tabs for session storage
            this.storageService.store(this.appGlobals.localStorageKeys.timer, timer + 1);
        } else {
            if (timer && (Date.now() > timer)) {
                //this.authenticationService.logout(true);
            }
        }
    }

    @HostListener("window:load", ["$event"])
    loadHandler(event) {
        setTimeout(() => {
            var currentUser = this.storageService.getStorage(this.appGlobals.localStorageKeys.currentUser);

            // redirect to home if already logged in
            if (currentUser && this.router.url.includes("login")) {
                location.reload();
            }
        }, 100);
    }

    //@HostListener("window:beforeunload", ["$event"])
    //beforeUnloadHandler(event) {
    //    if (event.clientX < 0 && event.clientY < 0) {
    //        console.log("Window closed");
    //    }
    //    else {
    //        console.log("Window refreshed");
    //    }
    //}
}